export default __webpack_public_path__ + "static/media/Image1Tablet.88021ca1.png";